var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(-2159 -4059.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M2213,4064.205v27a4.5,4.5,0,0,1-4.5,4.5h-45a4.3,4.3,0,0,1-1.53-.27,4.5,4.5,0,0,1-2.97-4.23v-27a4.5,4.5,0,0,1,4.5-4.5h45A4.5,4.5,0,0,1,2213,4064.205Z",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M2205.053,4077.97c0-2.71-1.313-4.848-3.822-4.848s-4.043,2.138-4.043,4.826c0,3.186,1.8,4.795,4.382,4.795a5.892,5.892,0,0,0,2.932-.688v-2.117a5.617,5.617,0,0,1-2.593.582c-1.027,0-1.937-.359-2.054-1.608h5.176C2205.031,4078.774,2205.053,4078.224,2205.053,4077.97Zm-5.229-1.006c0-1.2.73-1.694,1.4-1.694.646,0,1.334.5,1.334,1.694Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M2193.1,4073.122a2.99,2.99,0,0,0-2.074.825l-.138-.656h-2.329v12.342l2.647-.561.01-3a2.976,2.976,0,0,0,1.874.667c1.894,0,3.62-1.524,3.62-4.879C2196.7,4074.794,2194.955,4073.122,2193.1,4073.122Zm-.635,7.293a1.584,1.584,0,0,1-1.249-.5l-.01-3.927a1.575,1.575,0,0,1,1.259-.519c.963,0,1.63,1.08,1.63,2.467C2194.1,4079.356,2193.441,4080.415,2192.467,4080.415Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M2184.92,4072.5l2.657-.572v-2.149l-2.657.561Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 2.657,
    height: 9.262,
    transform: "translate(2184.92 4073.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M2182.073,4074.085l-.17-.783h-2.286v9.261h2.646v-6.276a1.866,1.866,0,0,1,2.011-.551V4073.3A1.8,1.8,0,0,0,2182.073,4074.085Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M2176.78,4071l-2.582.55-.011,8.479a2.66,2.66,0,0,0,2.742,2.72,4.1,4.1,0,0,0,1.852-.349v-2.149c-.339.137-2.011.624-2.011-.942v-3.758h2.011V4073.3h-2.011Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M2169.625,4075.99c0-.413.339-.571.9-.571a5.907,5.907,0,0,1,2.625.677v-2.487a6.972,6.972,0,0,0-2.625-.487c-2.149,0-3.578,1.122-3.578,2.995,0,2.922,4.022,2.456,4.022,3.715,0,.487-.423.646-1.016.646a6.6,6.6,0,0,1-2.89-.847v2.52a7.347,7.347,0,0,0,2.89.6c2.2,0,3.715-1.09,3.715-2.985C2173.658,4076.615,2169.625,4077.176,2169.625,4075.99Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStripe);
export default __webpack_public_path__ + "static/media/icon-stripe.327874026f09ed1171e482ad7e5171c4.svg";
export { ForwardRef as ReactComponent };